import Joi from "joi";

export const EditFolderFileSchema = Joi.object({
  fileName: Joi.string().required().messages({ "string.empty": "Required!" }),
});
